import {ChangeDetectionStrategy,Component,inject} from '@angular/core';
import {Meta,Title} from '@angular/platform-browser';
import {MATERIAL_IMPORTS} from '../shared/material-imports';
import {COMMON_IMPORTS} from '../shared/common-imports';
import {environment} from '../../environments/environment';
import {AppService} from '../app.service';

@Component({
	selector:'app-privacy-policy',
	imports:[
		...MATERIAL_IMPORTS,
		...COMMON_IMPORTS
	],
	templateUrl:'./privacy-policy.html',
	styleUrl:'./privacy-policy.scss',
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class PrivacyPolicyComponent{
	protected readonly environment=environment;

	readonly appService=inject(AppService);
	private readonly titleService=inject(Title);
	private readonly meta=inject(Meta);

	readonly title=$localize`:@@privacy-policy-title|Privacy policy page title:L&O Medical - Política de privacidad`;

	constructor(){
		const description=$localize`:@@privacy-policy-description|Privacy policy SEO description:Cómo L&O Medical recopila, usa y protege tus datos personales, incluida la información de salud que nos compartes al escribirnos.`;
		this.titleService.setTitle(this.title);
		this.meta.updateTag({content:this.title},'property="og:title"');
		this.meta.updateTag({content:description},'name="description"');
		this.meta.updateTag({content:description},'property="og:description"');
		this.meta.updateTag({content:$localize`:@@seo-keywords-default|Default SEO keywords:lyo, l&o, medical, medicina, biorreguladora, sueroterapia, autosanguis, bogotá, soacha, ibagué`},'name="keywords"');
		this.meta.updateTag({content:this.appService.ogImageUrl},'property="og:image"');
	}
}
